

import React, { useState, useImperativeHandle, forwardRef} from 'react'
import ModalView from '@/components/modal-view'
import CloseBtn from '../imgs/close@2x.png'
import styled from "styled-components";
import bgModal from '../images/bg1.png'

import title1 from '../images/进度条/title1.png';
import title8 from '../images/进度条/title8.png';
import title15 from '../images/进度条/title15.png';
import count1 from '../images/进度条/count1.png';


 const AwardModal =  forwardRef( (props, ref) => {
  const [showExplain, setShowExplain] = useState(false);
  const [name, setName] = useState('');
  const [titleImg, setTitleImg] = useState('');
  const [type, setType] = useState('prize');
  const [count, setCount] = useState(0)
  const options = {
    5: {
      title: '会员5天',
    },
    99999: {
      title: '通关卡',
    },
    3: {
      title: '会员3天',
    },
    93: {
      title: '会员季卡',
    },
    10: {
      title: '会员10天',
    },
    372: {
      title: '会员年卡',
    },
    15: {
      title: '会员15天',
    },
    31: {
      title: '会员月卡',
    }
  }

  const drawResult = {
    1: {
      title: '价投全景图纸质版',
      img: 'title1',
      tips: '需要购买会员后领取'
    },
    8: {
      title: '市值风云专属帆布袋',
      tips: '需要购买会员后领取',
      img: 'title8',
    },
    15: {
      title: '市值风云2024款保温杯',
      img: 'title15',
      tips: '需要购买会员后领取'
    }
  }


  useImperativeHandle(ref, () => ({
    show: (val, type ) => {
      if(type === 'draw') {
        setType(type)
   
        setName(drawResult[val].title)
        
        setTitleImg(drawResult[val].img)
        setShowExplain(true)
    
      } else {
        if(val >= 15) {
          setCount(1)
        } else {
          setCount(0)
        }
        setType('prize')
        setName(options[val].title)
        setShowExplain(true)
        setTitleImg('')
      }

    },
    hide: ()=> {
      // setShowExplain(false)
      handleClose()
    }
   }));


  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation()
    if(type === 'draw') {
      props.getDraw();
      setShowExplain(false)
    } else {
      props.unlock();
    }
  };
  const handleClose = (e) => {
    setShowExplain(false)
    if(type !== 'draw') {
      props.onClose();
    }
   
  };

  return (
    <ModalView
        visible={showExplain}
        onClose={() => handleClose()}
        onOverlayClick={() => handleClose()}
        content={
          <ExplainCard  className='award'>
            <div className="explain-card-wrap">
              <div className="explain-wrap">
                <div className="explain-card">
                  {
                    type === 'draw' &&  <div className='img_title'>
                    {
                      
                     (  titleImg === 'title1'? 
                        <img src={ title1 }  alt='' /> : 
                        titleImg === 'title8'? <img src={ title8 }  alt='' />: titleImg === 'title15'? <img src={ title15 }  alt='' />:'' )
                    }
                  </div>
                  } 
                  {
                    type === 'prize'  &&  count === 1 && <div className='img_title'>
                     <img src={ count1 }  alt='' />
                  </div>
                  }
                
                  <div className="explain-text">
                      <div className="award_text">
                      <div className="title">恭喜你  {type==='prize'?'抽中': '获得'}了</div>
                      <div className="name2">&nbsp;{name}&nbsp;</div>
                      <div className="description">
                         {
                          type === 'prize'
                          ? (props.isLock? '天数会加到已购会员中': '购买会员后该天数会加到对应会员天数中')
                          : ( props.isLock? '该奖品会在活动结束后统一发放': '需购买会员后领取')
                         }
                       </div>
                     
                      <div className="btn" onClick={handleClick}>
                      {
                        props.isLock?  
                        <img src={require('../images/btn1.png')} alt=''/>
                        :
                        <img src={require('../images/btn2.png')} alt=''/>
                      }
                     
                      </div>
                    </div>
                  </div>

                  {/* <img src={ExplainText} alt='' className="explain-img" /> */}
                </div>
                <div className="explain-close">
                  <img onClick={() => handleClose()} className="close-btn" src={CloseBtn} alt=""/>
                </div>
              </div>
            </div>
          </ExplainCard>
        }
      />
  )
  
})


export default AwardModal; 

const ExplainCard = styled.div`
  &.award  .explain-card-wrap  {
    .explain-wrap {
      background-image: url(${bgModal});
      background-repeat: no-repeat;
      background-size: contain;
      width: 272px;
      height: 420px;
    }
  }
  .explain-card-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    max-width: 334px;
    position: relative;
    padding-bottom: 60px;
   
    .explain-wrap {
      height: calc(100vh - 100px);
      .explain-card {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        .img_title {
          position: absolute;
          text-align: center;
          width: 100%;
          left: 0;
          top: 0;
          margin: auto;
          >img {
            height: 18px;
            // width: 176px;
            // width: 100%;
          }
        }
        .award_text {
          margin-top: 200px;
          text-align: center;
          .title {
            color: #000000;
            font-size: 20px;
            line-height: 20px;
          }
          .name {
            margin-top: 15px;
            font-size: 38px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #FF7825;
          }
          .name2 {
            font-size: 38px;
            margin-top: 15px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #FF7825;
          }
          .description {
            margin-top: 10px;
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #0E0509;
          }
          .btn {
            width: 171px;
            margin:auto;
            margin-top: 17px;
            font-size:0;
            >img {
              width: 100%;
            }
          }
        }
      
        &::-webkit-scrollbar {
          display: none;
        }
        &::-webkit-scrollbar {
          display: none;
        }
        .explain-img {
          width: 100%;
        }
        .explain-text {
          color: #fff;
          font-size: 30px;
          >img {
           width: 100%;
          }
        }
      }
      .explain-close {
        height: 60px;
        display: flex;
        width: 100%;
        justify-content: center;
        box-sizing: border-box;
        padding-top: 2px;
        .close-btn {
          width: 20px;
          height: 20px;
        }
      }
    }
  }


  .empty-wrap {
    position: relative;
    padding: 0 35px;
    width: 100%;
    max-width: 305px;
    .empty-card {
      width: 100%;
      height: 115.75px;
    }
    .empty-close-btn {
      right: 46px;
      top: 12px;
      width: 20px;
      height: 20px;
      position: absolute;
      z-index: 5;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_138/components/awardModal.js